export const restrictionTypes = [
  'game_rank',
  'team_rank',
  'user',
  'logged_in',
  'anyone',
] as const

type RestrictionType = typeof restrictionTypes[number]
export default RestrictionType
